(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3240],{

/***/ 75542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12.89 11.1c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.45-.82-1.92-2.54-2.24V5h-2v1.26c-2.48.56-2.49 2.86-2.49 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 2.9 2.96V19h2v-1.24c.4-.09 2.9-.59 2.9-3.22 0-1.39-.61-2.61-3.01-3.44zM3 21H1v-6h6v2H4.52c1.61 2.41 4.36 4 7.48 4 4.97 0 9-4.03 9-9h2c0 6.08-4.92 11-11 11-3.72 0-7.01-1.85-9-4.67V21zm-2-9C1 5.92 5.92 1 12 1c3.72 0 7.01 1.85 9 4.67V3h2v6h-6V7h2.48C17.87 4.59 15.12 3 12 3c-4.97 0-9 4.03-9 9H1z"
}), 'CurrencyExchange');
exports.Z = _default;

/***/ }),

/***/ 76172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'KeyboardArrowLeft');
exports.Z = _default;

/***/ }),

/***/ 48317:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
exports.Z = _default;

/***/ }),

/***/ 77349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 9686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ CustomRightArrow; },
/* harmony export */   "q": function() { return /* binding */ CustomLeftArrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48317);
/* harmony import */ var _mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76172);






var buttonStyles = {
    zIndex: 2,
    buttonOffset: 15,
    borderRadius: "50%",
    textAlign: "center",
    border: "1.5px solid #D4A976",
    backgroundColor: "#202020",
    color: "#D4A976",
    top: "calc(50% - 25px)",
    width: "50px",
    height: "50px",
    lineHeight: "50px",
    cursor: "pointer"
};
var CustomLeftArrow = function(param) {
    var onClick = param.onClick, left = param.left, position = param.position;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, buttonStyles), {
            left: left || 0,
            position: position || "absolute"
        }),
        onClick: function() {
            return onClick();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            fontSize: "large",
            style: {
                marginTop: "-0.25rem",
                marginRight: 2
            }
        })
    });
};
var CustomRightArrow = function(param) {
    var onClick = param.onClick, right = param.right, position = param.position;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, buttonStyles), {
            right: right || 0,
            position: position || "absolute"
        }),
        onClick: function() {
            return onClick();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            fontSize: "large",
            style: {
                marginTop: "-0.25rem",
                marginLeft: 2
            }
        })
    });
};


/***/ }),

/***/ 13240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ LandingPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(61715);
// EXTERNAL MODULE: ./components/index.js + 25 modules
var components = __webpack_require__(60306);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/LandingPage/LandingPage.module.scss
var LandingPage_module = __webpack_require__(33562);
var LandingPage_module_default = /*#__PURE__*/__webpack_require__.n(LandingPage_module);
// EXTERNAL MODULE: ./components/Carousel/arrows/arrows.jsx
var arrows = __webpack_require__(9686);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(86529);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/lib/styles.css
var styles = __webpack_require__(16494);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Lists/ReviewItem.jsx
var ReviewItem = __webpack_require__(74079);
// EXTERNAL MODULE: ./components/LandingPage/Currency/Currency.module.scss
var Currency_module = __webpack_require__(6542);
var Currency_module_default = /*#__PURE__*/__webpack_require__.n(Currency_module);
// EXTERNAL MODULE: ./node_modules/currency-symbol-map/currency-symbol-map.js
var currency_symbol_map = __webpack_require__(81463);
var currency_symbol_map_default = /*#__PURE__*/__webpack_require__.n(currency_symbol_map);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CurrencyExchange.js
var CurrencyExchange = __webpack_require__(75542);
;// CONCATENATED MODULE: ./components/LandingPage/Currency/Currency.jsx








var Currency = function(param) {
    var currency = param.currency, destination = param.destination;
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            width: "100%",
            filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.05))",
            backgroundColor: "#002F4A",
            padding: "1rem",
            textAlign: "left",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Currency_module_default()).icon),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyExchange/* default */.Z, {
                    className: "m-auto"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Currency_module_default()).currencyHeader, "font-fragment"),
                children: [
                    destination.name,
                    " currency is ",
                    destination.currency,
                    "\xa0(",
                    currency_symbol_map_default()(destination.currency),
                    ")"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Currency_module_default()).currencyContent, "font-libre"),
                children: [
                    "Current currency exchange rate is: ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "1 ",
                    userStore.currency,
                    " (",
                    currency_symbol_map_default()(userStore.currency),
                    ") =",
                    " ",
                    currency.Rate.toFixed(3),
                    " ",
                    destination.currency,
                    "(",
                    currency_symbol_map_default()(destination.currency),
                    ")",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "1 ",
                    destination.currency,
                    " (",
                    currency_symbol_map_default()(destination.currency),
                    ") =",
                    " ",
                    (1 / currency.Rate).toFixed(3),
                    " ",
                    userStore.currency,
                    "(",
                    currency_symbol_map_default()(userStore.currency),
                    ")"
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowRightAlt.js
var ArrowRightAlt = __webpack_require__(57354);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./components/RecommendationsList/RecommendationsList.jsx
var RecommendationsList = __webpack_require__(39972);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./utils/checkUserCountry.js
var checkUserCountry = __webpack_require__(65024);
// EXTERNAL MODULE: ./components/OffersViews/OffersViews.jsx + 3 modules
var OffersViews = __webpack_require__(87302);
;// CONCATENATED MODULE: ./components/LandingPage/LandingPage.jsx






















var CallToSignUp = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8307), __webpack_require__.e(8746)]).then(__webpack_require__.bind(__webpack_require__, 68307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68307)
            ];
        }
    }
});
var ScrollableContent = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 55542));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55542)
            ];
        }
    }
});
var RegionalDealsTable = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8335).then(__webpack_require__.bind(__webpack_require__, 58335));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58335)
            ];
        }
    },
    ssr: false
});
// const FeaturedContent = dynamic(() =>
//   import('../FeaturedContent/FeaturedContent')
// );
var FeaturedContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5808).then(__webpack_require__.bind(__webpack_require__, 5808));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5808)
            ];
        }
    }
});
var responsive = {
    superLargeDesktop: {
        breakpoint: {
            max: 4000,
            min: 3000
        },
        items: 2,
        slidesToSlide: 2
    },
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 2,
        slidesToSlide: 2
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 1,
        slidesToSlide: 1
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0
        },
        items: 1,
        slidesToSlide: 1
    }
};
var LandingPage = function(param) {
    var //setLoginDialogState,
    landing = param.landing, authCompleted = param.authCompleted, yrWeatherWidgetURL = param.yrWeatherWidgetURL, currency = param.currency, recommendation = param.recommendation, selfUrl = param.selfUrl, _isPreview = param.isPreview, isPreview = _isPreview === void 0 ? false : _isPreview;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var ref24 = (0,react.useState)(0), carouselHeight = ref24[0], setCarouselHeight = ref24[1];
    var ref25 = (0,react.useState)(null), searchBoxState = ref25[0], setSearchBoxState = ref25[1];
    var ref26 = (0,react.useState)(false), dealsAvailable = ref26[0], setDealsAvailable = ref26[1];
    var ref27 = (0,react.useState)("100%"), weatherIframeWidth = ref27[0], setWeatherIframeWidth = ref27[1];
    var carousel = /*#__PURE__*/ (0,react.createRef)();
    var origin = landing.cityFrom || landing.countryFrom || landing.regionFrom || null;
    var destination = landing.cityTo || landing.countryTo || landing.regionTo;
    var destinationCode = ((ref = landing.cityTo) === null || ref === void 0 ? void 0 : ref.code) || null;
    var originCountryCode = ((ref1 = landing.cityFrom) === null || ref1 === void 0 ? void 0 : ref1.countryCode) || null;
    var originCode = ((ref2 = landing.cityFrom) === null || ref2 === void 0 ? void 0 : ref2.code) || null;
    var originCurrency = ((ref3 = landing.cityFrom) === null || ref3 === void 0 ? void 0 : ref3.currency) || null;
    var options = {
        replace: function(domNode) {
            if (domNode.type === "tag" && domNode.name === "a") {
                var ref, ref1;
                if ((ref = domNode.attribs) === null || ref === void 0 ? void 0 : (ref1 = ref.href) === null || ref1 === void 0 ? void 0 : ref1.includes("http")) {
                    var ref2, ref3, ref4;
                    if (((ref2 = domNode.attribs) === null || ref2 === void 0 ? void 0 : ref2.target) === "_blank") {
                        domNode.attribs.target = "_blank";
                    }
                    if ((ref3 = domNode.attribs) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.rel) === null || ref4 === void 0 ? void 0 : ref4.includes("sponsored")) {
                        domNode.attribs.rel = "noreferrer noopener sponsored";
                    } else {
                        domNode.attribs.rel = "noreferrer noopener nofollow";
                    }
                }
            }
        }
    };
    var replaceContent = function(content) {
        return (0,html_react_parser/* default */.ZP)(content, options);
    };
    var defaultOrigin = (0,react.useMemo)(function() {
        return {
            country: originCountryCode || (userStore === null || userStore === void 0 ? void 0 : userStore.country),
            origin: originCode
        };
    }, [
        userStore === null || userStore === void 0 ? void 0 : userStore.country
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setCarouselHeight(((ref = carousel.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) / 1.3);
        setWeatherIframeWidth(width > 1024 ? "800px" : "100%");
    }, [
        carousel,
        width
    ]);
    (0,react.useEffect)(function() {
        if (destination) {
            var getCabinClassCode = function(textId) {
                switch(textId){
                    case "business-class":
                        return "BIZ";
                    case "premium-economy-class":
                        return "FLX";
                    case "first-class":
                        return "FST";
                    default:
                        return "ECO";
                }
            };
            setSearchBoxState({
                from: (origin === null || origin === void 0 ? void 0 : origin.name) + " " + (origin === null || origin === void 0 ? void 0 : origin.countryName) || null,
                exactFrom: false,
                to: (destination === null || destination === void 0 ? void 0 : destination.name) + " " + (destination === null || destination === void 0 ? void 0 : destination.countryName) || null,
                exactTo: false,
                tripState: "round_trip",
                cabinClass: getCabinClassCode(landing.textIdClass),
                dateRange: {
                    departure: (0,format/* default */.Z)((0,addDays/* default */.Z)(new Date(), 7), "yyyy-MM-dd"),
                    return: (0,format/* default */.Z)((0,addDays/* default */.Z)(new Date(), 8), "yyyy-MM-dd")
                },
                departure: null,
                airlineType: "all",
                passengers: {
                    adults: 1
                },
                multi_city: [
                    {
                        from: null,
                        to: null,
                        departure: null,
                        airlineType: "all"
                    }, 
                ]
            });
        }
    }, [
        landing
    ]);
    var generateCabinClass = function() {
        switch(landing.textIdClass){
            case "economy-class":
                return {
                    name: "Economy Class",
                    code: "ECO"
                };
            case "premium-economy-class":
                return {
                    name: "Premium Economy Class",
                    code: "FLX"
                };
            case "business-class":
                return {
                    name: "Business Class",
                    code: "BIZ"
                };
            case "first-class":
                return {
                    name: "First Class",
                    code: "FST"
                };
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    (origin === null || origin === void 0 ? void 0 : origin.name) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "Cheap ",
                            generateCabinClass().name,
                            " Flights from ",
                            origin.name,
                            " to",
                            " ",
                            destination.name,
                            " - First-Class.com"
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "Cheap ",
                            generateCabinClass().name,
                            " Flights to ",
                            destination.name,
                            " - First-Class.com"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat("https://www.first-class.com", "/flights/").concat(selfUrl.join("/"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: !(origin === null || origin === void 0 ? void 0 : origin.name) ? "Search compare, and book the best ".concat(generateCabinClass().name, " flight deals to ").concat(destination.name, ".  Secure the cheapest, and fastest round-trip business class tickets to ").concat(destination.name, ".") : "Search and compare the best deals on ".concat(generateCabinClass().name, " flights from ").concat(origin.name, " to ").concat(destination.name, ". Search 100+ sites & book your ").concat(generateCabinClass().name, " tickets from ").concat(origin.name, " to ").concat(destination.name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "first-class.com"
                    }),
                    (origin === null || origin === void 0 ? void 0 : origin.name) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Cheap ".concat(generateCabinClass().name, " Flights \n            ").concat(origin.name, " to ").concat(destination.name, " -\n            First-Class.com")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Cheap ".concat(generateCabinClass().name, " Flights to ").concat(destination.name, " -\n            First-Class.com")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: !(origin === null || origin === void 0 ? void 0 : origin.name) ? "Search compare, and book the best ".concat(generateCabinClass().name, " flight deals to ").concat(destination.name, ".  Secure the cheapest, and fastest round-trip business class tickets to ").concat(destination.name, ".") : "Search and compare the best deals on ".concat(generateCabinClass().name, " flights from ").concat(origin.name, " to ").concat(destination.name, ". Search 100+ sites & book your ").concat(generateCabinClass().name, " tickets from ").concat(origin.name, " to ").concat(destination.name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://media.first-class.com/" + ((ref4 = landing.image) === null || ref4 === void 0 ? void 0 : ref4.replace("/", ""))
                    }),
                    (origin === null || origin === void 0 ? void 0 : origin.name) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Cheap ".concat(generateCabinClass().name, " Flights \n            ").concat(origin.name, " to ").concat(destination.name, " -\n            First-Class.com")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Cheap ".concat(generateCabinClass().name, " Flights to ").concat(destination.name, " -\n            First-Class.com")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://media.first-class.com/" + (landing === null || landing === void 0 ? void 0 : (ref5 = landing.image) === null || ref5 === void 0 ? void 0 : ref5.replace("/", ""))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: !(origin === null || origin === void 0 ? void 0 : origin.name) ? "Search compare, and book the best ".concat(generateCabinClass().name, " flight deals to ").concat(destination.name, ".  Secure the cheapest, and fastest round-trip business class tickets to ").concat(destination.name, ".") : "Search and compare the best deals on ".concat(generateCabinClass().name, " flights from ").concat(origin.name, " to ").concat(destination.name, ". Search 100+ sites & book your ").concat(generateCabinClass().name, " tickets from ").concat(origin.name, " to ").concat(destination.name)
                    }),
                    (((ref6 = landing.questionsAnswers) === null || ref6 === void 0 ? void 0 : ref6.length) || ((ref7 = landing.questionsAnswersDirection) === null || ref7 === void 0 ? void 0 : ref7.length) || landing.questionsAnswersDestination) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: ((ref8 = landing.questionsAnswers) === null || ref8 === void 0 ? void 0 : ref8.length) ? JSON.stringify({
                                mainEntity: landing.questionsAnswers.map(function(item) {
                                    return {
                                        name: item.question,
                                        acceptedAnswer: {
                                            text: item.answer,
                                            "@type": "Answer"
                                        },
                                        "@type": "Question"
                                    };
                                }),
                                "@type": "FAQPage",
                                "@context": "http://schema.org"
                            }) : ((ref9 = landing.questionsAnswersDirection) === null || ref9 === void 0 ? void 0 : ref9.length) ? JSON.stringify({
                                mainEntity: landing.questionsAnswersDirection.map(function(item) {
                                    return {
                                        name: item.question,
                                        acceptedAnswer: {
                                            text: item.answer,
                                            "@type": "Answer"
                                        },
                                        "@type": "Question"
                                    };
                                }),
                                "@type": "FAQPage",
                                "@context": "http://schema.org"
                            }) : ((ref10 = landing.questionsAnswersDestination) === null || ref10 === void 0 ? void 0 : ref10.length) ? JSON.stringify({
                                mainEntity: landing.questionsAnswersDestination.map(function(item) {
                                    return {
                                        name: item.question,
                                        acceptedAnswer: {
                                            text: item.answer,
                                            "@type": "Answer"
                                        },
                                        "@type": "Question"
                                    };
                                }),
                                "@type": "FAQPage",
                                "@context": "http://schema.org"
                            }) : null
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((LandingPage_module_default()).landing),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((LandingPage_module_default()).topSection, dealsAvailable ? (LandingPage_module_default()).topDeals : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "vjs-tech",
                                src: "https://media.first-class.com/" + ((ref11 = landing.image) === null || ref11 === void 0 ? void 0 : ref11.replace("/", "")),
                                alt: "Top image",
                                layout: "fill",
                                objectFit: "cover"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: classnames_default()((LandingPage_module_default()).topSectionText, "font-fragment", dealsAvailable ? (LandingPage_module_default()).topDeals : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            " ",
                                            generateCabinClass().name,
                                            " "
                                        ]
                                    }),
                                    " flights",
                                    (origin === null || origin === void 0 ? void 0 : origin.name) ? " from " + origin.name : "",
                                    destination && " to " + destination.name
                                ]
                            }),
                            userStore && userStore.country && (0,checkUserCountry/* checkUserCountry */.u)(originCountryCode || userStore.country) && destinationCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((LandingPage_module_default()).dealsTable, "container"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionalDealsTable, {
                                    country: originCountryCode || userStore.country,
                                    currency: originCurrency || userStore.currency,
                                    origin: originCode,
                                    destination: destinationCode,
                                    cabinClass: generateCabinClass().code,
                                    cabinClassTitle: generateCabinClass().name,
                                    intervalSeconds: 7,
                                    setDealsAvailable: setDealsAvailable
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LandingPage_module_default()).content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((LandingPage_module_default()).topSectionSearch, "container mx-auto px-4", dealsAvailable ? (LandingPage_module_default()).topDeals : ""),
                                        children: width >= 1024 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SearchBox */.Rj, {
                                            type: "mainSearch",
                                            activeTab: 0,
                                            flightSearchValue: searchBoxState,
                                            searchSource: "Flights landing page"
                                        })
                                    }),
                                    width < 1024 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((LandingPage_module_default()).contentSearch, "mx-auto"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SearchBox */.Rj, {
                                            type: "sideSearch",
                                            activeTab: 0,
                                            flightSearchValue: searchBoxState,
                                            searchSource: "Flights landing page"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersViews/* OffersViews */.Y, {
                                    defaultOrigin: defaultOrigin,
                                    defaultDestination: {
                                        destination: destinationCode
                                    },
                                    defaultCabinClass: generateCabinClass().code,
                                    filtersShown: false,
                                    searchSource: "Offer on Flights landing page",
                                    customHeader: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        className: "font-libre text-xl my-5 lg:my-10",
                                        children: [
                                            "Latest ",
                                            generateCabinClass().name,
                                            " round-trip flight deals ",
                                            (origin === null || origin === void 0 ? void 0 : origin.name) ? " from " + origin.name : "",
                                            destination && " to " + destination.name
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LandingPage_module_default()).contentBox,
                                children: [
                                    !!(landing === null || landing === void 0 ? void 0 : landing.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((LandingPage_module_default()).introductionDescription, "font-libre mt-8"),
                                        children: replaceContent(landing.content)
                                    }),
                                    !!((ref12 = landing.questionsAnswers) === null || ref12 === void 0 ? void 0 : ref12.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col justify-center items-center sm:px-5 my-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                className: classnames_default()((LandingPage_module_default()).listTitle),
                                                children: [
                                                    "FAQs - Booking \xa0",
                                                    destination.name,
                                                    " \xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            generateCabinClass().name,
                                                            " "
                                                        ]
                                                    }),
                                                    " \xa0Flights"
                                                ]
                                            }),
                                            landing.questionsAnswers.map(function(faq) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContent, {
                                                    heading: faq.question,
                                                    content: faq.answer,
                                                    style: (LandingPage_module_default()).scrollableContent
                                                }, faq.id);
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !!landing.contentDirection && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LandingPage_module_default()).contentBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: classnames_default()((LandingPage_module_default()).introductionHeading, "font-fragment mt-7"),
                                        children: [
                                            origin === null || origin === void 0 ? void 0 : origin.name,
                                            " to ",
                                            destination === null || destination === void 0 ? void 0 : destination.name,
                                            " direction"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((LandingPage_module_default()).introductionDescription, "font-libre"),
                                        children: replaceContent(landing.contentDirection)
                                    }),
                                    !!((ref13 = landing.questionsAnswersDirection) === null || ref13 === void 0 ? void 0 : ref13.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col justify-center items-center sm:px-5 my-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                className: classnames_default()((LandingPage_module_default()).listTitle),
                                                children: [
                                                    origin.name,
                                                    " to ",
                                                    destination === null || destination === void 0 ? void 0 : destination.name,
                                                    " flight FAQs"
                                                ]
                                            }),
                                            landing.questionsAnswersDirection.map(function(faq) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContent, {
                                                    heading: faq.question,
                                                    content: faq.answer,
                                                    style: (LandingPage_module_default()).scrollableContent
                                                }, faq.id);
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !!((ref14 = landing.destinations) === null || ref14 === void 0 ? void 0 : ref14.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((LandingPage_module_default()).contentBox, "flex items-center flex-col"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DestinationItem */.ex, {
                                    item: landing.destinations[0]
                                })
                            })
                        ]
                    }),
                    !!((ref15 = landing.articles) === null || ref15 === void 0 ? void 0 : ref15.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (LandingPage_module_default()).darkContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                            triggerOnce: true,
                            children: function(param) {
                                var inView = param.inView, ref = param.ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: ref,
                                    className: "container mx-auto px-4 lg:px-0",
                                    children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedContent, {
                                        items: landing.articles,
                                        enableInfinite: true
                                    })
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LandingPage_module_default()).contentBox,
                                children: [
                                    !!landing.contentDestination && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()((LandingPage_module_default()).introductionDescription, "font-libre mt-7"),
                                            children: replaceContent(landing.contentDestination)
                                        })
                                    }),
                                    !!((ref16 = landing.airlines) === null || ref16 === void 0 ? void 0 : ref16.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: classnames_default()((LandingPage_module_default()).listTitle),
                                                children: "Airlines that fly direct"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (LandingPage_module_default()).airlinesContainer,
                                                children: landing.airlines.map(function(airline) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (LandingPage_module_default()).airline,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: airline.logo,
                                                                alt: airline.name,
                                                                className: (LandingPage_module_default()).airlineLogo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (LandingPage_module_default()).airlineName,
                                                                children: airline.name
                                                            })
                                                        ]
                                                    }, airline.name);
                                                })
                                            })
                                        ]
                                    }),
                                    !!((ref17 = landing.airports) === null || ref17 === void 0 ? void 0 : ref17.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                className: classnames_default()((LandingPage_module_default()).listTitle),
                                                children: [
                                                    "Airports in ",
                                                    destination.name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (LandingPage_module_default()).airlinesContainer,
                                                children: landing.airports.map(function(airport) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: (LandingPage_module_default()).airline,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            className: (LandingPage_module_default()).airlineName,
                                                            children: [
                                                                airport.name,
                                                                " (",
                                                                airport.code,
                                                                ")"
                                                            ]
                                                        })
                                                    }, airport.id);
                                                })
                                            })
                                        ]
                                    }),
                                    !!(destination === null || destination === void 0 ? void 0 : destination.currency) && (currency === null || currency === void 0 ? void 0 : currency.Rate) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Currency, {
                                            currency: currency,
                                            destination: destination
                                        })
                                    })
                                ]
                            }),
                            yrWeatherWidgetURL && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    src: yrWeatherWidgetURL,
                                    width: weatherIframeWidth,
                                    height: "530px",
                                    style: {
                                        borderRadius: "12px",
                                        filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.05))",
                                        margin: "auto"
                                    }
                                })
                            }),
                            !yrWeatherWidgetURL && isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Weather forecast unavailable for preview"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LandingPage_module_default()).contentBox,
                                children: !!((ref18 = landing.questionsAnswersDestination) === null || ref18 === void 0 ? void 0 : ref18.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col justify-center items-center sm:px-5 my-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                            className: classnames_default()((LandingPage_module_default()).listTitle),
                                            children: [
                                                destination === null || destination === void 0 ? void 0 : destination.name,
                                                " FAQs"
                                            ]
                                        }),
                                        landing.questionsAnswersDestination.map(function(faq) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContent, {
                                                heading: faq.question,
                                                content: faq.answer,
                                                style: (LandingPage_module_default()).scrollableContent
                                            }, faq.id);
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    !!((ref19 = landing.hotels) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.content) === null || ref20 === void 0 ? void 0 : ref20.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((LandingPage_module_default()).darkContainer, "mt-10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((LandingPage_module_default()).hotelsOverflow, "container pb-8"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    className: classnames_default()((LandingPage_module_default()).heading, "text-center text-white font-fragment mb-10"),
                                    children: [
                                        "Luxury Hotels in ",
                                        destination === null || destination === void 0 ? void 0 : destination.name
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                                    infinite: true,
                                    responsive: responsive,
                                    autoPlaySpeed: 5000,
                                    containerClass: (LandingPage_module_default()).carouselContainer,
                                    customLeftArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrows/* CustomLeftArrow */.q, {
                                        left: width < 1024 ? 10 : 0,
                                        position: "absolute"
                                    }),
                                    customRightArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrows/* CustomRightArrow */.i, {
                                        right: width < 1024 ? 10 : 0,
                                        position: "absolute"
                                    }),
                                    children: (ref21 = landing.hotels) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.content) === null || ref22 === void 0 ? void 0 : ref22.map(function(item) {
                                        var ref;
                                        if (((ref = item.image) === null || ref === void 0 ? void 0 : ref[0]) === "/") {
                                            var ref1;
                                            item.image = (ref1 = item.image) === null || ref1 === void 0 ? void 0 : ref1.replace("/", "");
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mx-10 bg-white",
                                            style: {
                                                height: carouselHeight
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem/* ReviewItem */.r, {
                                                type: "Hotel",
                                                starRating: true,
                                                review: item,
                                                url: "/hotel/review/".concat(item.textId)
                                            })
                                        }, item.textId);
                                    })
                                })
                            ]
                        })
                    }),
                    !!((ref23 = landing.popularDestination) === null || ref23 === void 0 ? void 0 : ref23.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LandingPage_module_default()).contentBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: classnames_default()((LandingPage_module_default()).listTitle),
                                    children: "Popular flight roots"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LandingPage_module_default()).popularDestinationsContainer,
                                    children: landing.popularDestination.map(function(destination) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (LandingPage_module_default()).popularDestination,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (LandingPage_module_default()).popularDestinationName,
                                                    children: origin.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (LandingPage_module_default()).popularDestinationName,
                                                    children: destination.cityTo
                                                })
                                            ]
                                        }, destination.directionId);
                                    })
                                })
                            ]
                        })
                    }),
                    userStore && !userStore.userid && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                        triggerOnce: true,
                        children: function(param) {
                            var inView = param.inView, ref = param.ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                ref: ref,
                                className: "w-full mx-auto mb-20 sm:mb-10",
                                children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToSignUp, {
                                    country: userStore === null || userStore === void 0 ? void 0 : userStore.country,
                                    authCompleted: authCompleted,
                                    sourcePage: generateCabinClass().name + " FlightLandingPage"
                                })
                            });
                        }
                    }),
                    !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container flex justify-center items-center sm:w-full mt-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationsList["default"], {
                            items: recommendation
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 39972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RecommendationsList": function() { return /* binding */ RecommendationsList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _RecommendationItem_RecommendationItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82039);
/* harmony import */ var _RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60815);
/* harmony import */ var _RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var RecommendationsList = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, _hideHeading = param.hideHeading, hideHeading = _hideHeading === void 0 ? false : _hideHeading, listView = param.listView, props = param.props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().listContainer)),
        children: [
            !hideHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().listTitle), "text-3xl font-fragment sm:mb-10 mb-20"),
                children: "More from First-Class.com"
            }),
            !listView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemBlock), items.length > 1 && "lg:grid lg:grid-cols-2 lg:gap-x-8"),
                children: !!items.length && items.map(function(item, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(items.length > 1 && i === items.length - 1 && (_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().halfWidth), (_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RecommendationItem_RecommendationItem__WEBPACK_IMPORTED_MODULE_2__/* .RecommendationItem */ .A, {
                            item: item
                        }, item.title)
                    }, item.title);
                })
            }),
            listView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemBlock), items.length > 1 && "flex flex-col items-center"),
                children: !!items.length && items.map(function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RecommendationItem_RecommendationItem__WEBPACK_IMPORTED_MODULE_2__/* .RecommendationItem */ .A, {
                            item: item
                        }, item.title)
                    }, item.title);
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (RecommendationsList);


/***/ }),

/***/ 6542:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"currencyHeader":"Currency_currencyHeader__vRFAd","currencyContent":"Currency_currencyContent__cRjCo","icon":"Currency_icon__OXdKw"};

/***/ }),

/***/ 33562:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"landing":"LandingPage_landing__4Wkhn","introductionHeading":"LandingPage_introductionHeading___QneP","airlinesContainer":"LandingPage_airlinesContainer__hDq1D","airline":"LandingPage_airline__4SO6s","airlineLogo":"LandingPage_airlineLogo__L_7yc","topSectionSearch":"LandingPage_topSectionSearch__2XrwC","topDeals":"LandingPage_topDeals__xE5lk","contentSearch":"LandingPage_contentSearch__JwX41","topSection":"LandingPage_topSection__VEi96","topSectionText":"LandingPage_topSectionText__xV3_Y","introductionDescription":"LandingPage_introductionDescription__QEW2a","content":"LandingPage_content__KVj_T","contentBox":"LandingPage_contentBox__JT164","scrollableContent":"LandingPage_scrollableContent__LV1Uh","listTitle":"LandingPage_listTitle__oRb_S","darkContainer":"LandingPage_darkContainer__nLG_1","heading":"LandingPage_heading__93Oz2","popularDirectionsText":"LandingPage_popularDirectionsText__XtBSR","popularDirectionsSeoHTML":"LandingPage_popularDirectionsSeoHTML__vk_8i","popularDirectionsList":"LandingPage_popularDirectionsList__LhZq_","popularDirectionsListPagination":"LandingPage_popularDirectionsListPagination__RfiTG","popularDirectionsListPaginationItem":"LandingPage_popularDirectionsListPaginationItem___S80d","card":"LandingPage_card__CYbW_","recomendationContainer":"LandingPage_recomendationContainer__DZ5Bj","imageContainer":"LandingPage_imageContainer__PcWOI","text":"LandingPage_text__1FaZc","type":"LandingPage_type__U4_Yz","title":"LandingPage_title__Oae0H","icon":"LandingPage_icon__c4X3Y","readMore":"LandingPage_readMore__S_KhB","scrollableContentSub":"LandingPage_scrollableContentSub__WBGaS","seoContent":"LandingPage_seoContent__4OHrX","dealsTable":"LandingPage_dealsTable__IT8jf","dealsTableRegion":"LandingPage_dealsTableRegion__UJdPU"};

/***/ }),

/***/ 60815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"RecommendationsList_listContainer__zOMv6","listTitle":"RecommendationsList_listTitle__pJJNc","halfWidth":"RecommendationsList_halfWidth__ejpzI"};

/***/ })

}]);